var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"percentloop"},[_c('div',{staticClass:"circle-left"},[_c('div',{ref:"leftcontent"})]),_c('div',{staticClass:"circle-right"},[_c('div',{ref:"rightcontent"})]),_c('div',{staticClass:"number"},[_vm._v(" "+_vm._s(_vm.percent)+" % ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }